import React, { useState, useEffect, act } from 'react';
import style from "./css/UpgradePage.module.css";
import { apiURL_BACKEND, UserDataInterface, PackagePassInterface, useJustifyUserType, PackageInterface, TestimonialInterface, AgentPackage, formatTitleText, userPackageInterface } from './Vars';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
interface UpgradePageProps {

}

const UpgradePage: React.FC<UpgradePageProps> = () => {
    const navigate = useNavigate();
    const userType = useJustifyUserType();
    const [userData, setUserData] = useState<UserDataInterface>();
    const [packagePasses, setPackagePasses] = useState<PackagePassInterface[]>([]);



    ///GET USER DATA
    useEffect(() => {


        const res = axios.get(`${apiURL_BACKEND}/getUser/`, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem('access_token')}`,
            },
        }).then((res) => {
            var data = res.data;
            console.log(data);

            setUserData({
                username: data.username,
                email: data.email,
                referrer: data.referrer,
                refer_code: data.refer_code,
                date_joined: data.date_joined,
                package: data.package,
                balance: data.balance,
                user_type: data.user_type,
                tme_username: data.tme_username
            })
        });


        // setUserData({
        //     username:res.
        // })
    }, [])
    useEffect(() => { console.log("user data ", userData) }, [userData])
    //GET ALL AVALIABLE PACKS FOR THE USER
    useEffect(() => {
        if (userData) {
            axios.get(`${apiURL_BACKEND}/getAllPackagePasses/`,
                {
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem('access_token')}`,
                    },
                }
            ).then((res) => {

                var data: Array<PackagePassInterface> = JSON.parse(res.data.allPackagePasses);
                console.log(data);
                setPackagePasses(data);

            }).catch(() => (console.log("DO NOTHING")))
        }
    }, [userData])
    /////////////





    const buyPlan = (type: string, productID: number) => {
        navigate(`/checkout/?type=${type}&productID=${productID}`);
    }


    const [agentPackages, setAgentPackages] = useState<Array<AgentPackage>>([]);
    useEffect(() => {
        axios.get(`${apiURL_BACKEND}/getAgentPackages/`).then((res) => {
            const data = res.data;
            setAgentPackages(data.packages);
            // console.log("Packages ", data.packages);
        })
    }, [])
    const [allPackages, setAllPackages] = useState<Array<PackageInterface>>([]);
    const [package_types, set_package_types] = useState([]);
    const [sport_types, set_sport_types] = useState([]);
    useEffect(() => {
        console.log("all packages")
        axios.get(`${apiURL_BACKEND}/getAllPackages/`, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem('access_token')}`,
            },
        }).then((res) => {
            const data = res.data;
            setAllPackages(JSON.parse(data.packages));
            // console.log("all packages ", res.data);
        }).catch((err) => { console.log(err); })
    }, [])

    const [activePackages, setActivePackages] = useState<Array<userPackageInterface>>([]);
    useEffect(() => {
        axios.get(`${apiURL_BACKEND}/getActivePackages/`, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem('access_token')}`,
            },
        }).then((res) => {
            const data = res.data;
            setActivePackages(JSON.parse(data.packages));
            

        }).catch((err) => { console.log(err) })
    }, [])
    useEffect(()=>{
        console.log(activePackages);
    },[activePackages])

    return (
        <>

            <div className={style.myBalance}> {userData?.balance} $</div>
            <div className={style.picksPalace}>
                <div className={style.pseudoSideNav}>

                </div>
                <div className={style.picksPalaceMain}>

                    {
                        userData?.user_type == "Agent" ? (
                            <>
                                <div className={style.section1}>
                                    <div className={style.currentPlan}>
                                        <p className={style.currentPlanTitle}>
                                            Current Plan
                                        </p>

                                        <div className={style.currentPlanCard}>

                                            <div className={style.packDetails}>
                                                <div>
                                                    <div className={style.cardTitle} style={{ whiteSpace: "wrap", width: "100%" }}>
                                                        {

                                                            userData?.package ?
                                                                (
                                                                    <div >
                                                                        <p>Current Plan</p>
                                                                        <span className={style.cardTitle_packageType}>{userData.package.name}</span>

                                                                    </div>

                                                                ) :
                                                                (
                                                                    <div >
                                                                        <p className={style.cardTitle_noPlanActive}>No Plans Activated</p>
                                                                        <span className={style.cardTitle_packageType}>{agentPackages[0].name} :

                                                                            <div className={style.amount}>
                                                                                <p>{agentPackages[0].price} USD</p>
                                                                                {/* <span>(-3%)</span> */}
                                                                            </div>
                                                                        </span>
                                                                    </div>
                                                                )

                                                        }
                                                    </div>
                                                </div>

                                            </div>


                                            <ul className={style.ul1}>
                                                <li>1 month of free access to all picks.</li>
                                            </ul>
                                            <div className={style.card_1m}>
                                                <p className={style.t1}>
                                                    After the 1st month
                                                </p>
                                                <ul className={style.ul2}>
                                                    <li>5 picks per day.</li>
                                                    <li>DayPass: 99 USD .</li>
                                                    <li>WeekPass: 299 USD .</li>
                                                    <li>MonthPass: 699 USD .</li>
                                                </ul>
                                            </div>
                                            {/* {
                                                userData?.package && userData?.package != "IMPERIAL" ?
                                                    (<>
                                                        <div className={style.upgradeButton} onClick={(e) => { e.preventDefault(); buyPlan('package', 3); }}>
                                                            Upgrade Plan

                                                        </div>

                                                    </>) :


                                                    (<>
                                                        <div className={style.upgradeButton} onClick={(e) => { e.preventDefault(); buyPlan('package', 1); }}>
                                                            Buy a Package

                                                        </div>

                                                    </>)
                                            } */}

                                        </div>
                                    </div>

                                    <div className={style.premiumPlan}>
                                        {/* {
                                            userData?.package != "PREMIUM" ? (
                                                <>
                                                    <h2 className={style.prePlanHeader1}>
                                                        Upgrade to premium !
                                                    </h2>
                                                </>
                                            ) :
                                                (
                                                    <h2 className={style.prePlanHeader1}>
                                                        Upgrade to Imperial
                                                    </h2>
                                                )
                                        } */}

                                        <p className={style.prePlanT1}>
                                            Premium Pack–$899(includes one month of free access to all picks)
                                        </p>

                                        <div className={style.prePlanAdvantages}>
                                            <h2 className={style.prePlanAdvantagesHeader1}>
                                                After the first month (6 picks per day):
                                            </h2>
                                            <ul className={style.prePlanAdvantages_ul}>
                                                <li className={style.prePlanAdvatages_li}>DayPass: $79</li>
                                                <li className={style.prePlanAdvatages_li}>MonthPass: $549</li>
                                                <li className={style.prePlanAdvatages_li}>WeekPass: $249</li>
                                                <li className={style.prePlanAdvatages_li}>YearPass: $5,499</li>
                                            </ul>

                                        </div>
                                        {/* {
                                            userData?.package != "PREMIUM" ? (
                                                <>
                                                    <button className={style.upgradePremiumPlanButton} onClick={(e) => { e.preventDefault(); buyPlan('package', 2); }}>
                                                        Upgrade now
                                                    </button>
                                                </>
                                            ) :
                                                (
                                                    <>
                                                        <button className={style.upgradePremiumPlanButton} onClick={(e) => { e.preventDefault(); buyPlan('package', 3); }}>
                                                            Upgrade to Imperial
                                                        </button>
                                                    </>
                                                )
                                        } */}

                                    </div>
                                </div>


                                <h1 className={style.userPackageTitle}>
                                    Upgrade Your Agent Package
                                </h1>


                                <div className={style.allPackages}>
                                    {
                                        agentPackages.map((_pack) => {
                                            return <>

                                                <div>

                                                    <div
                                                        className={style.pack}

                                                    >


                                                        <p className={style.packTitle}  >{_pack.name}</p>
                                                        <p className={style.packPrice}  >( only at {_pack.price} $ )</p>



                                                        <>
                                                            <div className={style.packsTexts1}>
                                                                <p className={style.pt_title}>Unlock new road</p>
                                                                <ul className={style.pt_ul}>
                                                                    <li>{_pack.title} </li>

                                                                </ul>
                                                            </div>
                                                        </>





                                                        <p className={style.packT1}>
                                                            🔓 Unlock 5 expert picks every day! Stay ahead of the game with insights tailored to maximize your winnings.
                                                        </p>

                                                        <div className={style.hrLine}></div>


                                                        <p className={style.packT2} dangerouslySetInnerHTML={{ __html: _pack.description }}></p>

                                                        {/* <ul className={style.pt_ul2}>
                                                            <li>Access to all Daily Picks</li>
                                                            <li>Weekly Profit Boost</li>
                                                            <li>Maximize Your Winnings</li>
                                                            <li>Expert Picks Daily</li>
                                                            <li>Dominate the Game</li>
                                                        </ul> */}

                                                        {
                                                            userData.package?.name == _pack.name ? (
                                                                <div className={style.upgradeButton} style={{ backgroundColor: "#BCC0BC" }}>
                                                                    Current Plan
                                                                </div>
                                                            ) : (

                                                                <>

                                                                    <div className={style.upgradeButton} onClick={(e) => { e.preventDefault(); buyPlan('agent_package', Number(_pack.pk)); }} style={{ marginTop: "20px" }}>
                                                                        Upgrade
                                                                    </div>


                                                                </>

                                                            )
                                                        }
                                                    </div>
                                                </div>
                                            </>
                                        })
                                    }
                                </div>


                            </>
                        ) :
                            (
                                <>


                                </>
                            )
                    }

                    {/* {
                        packagePasses.length > 0 ? (
                            <>
                                <h1 className={style.userPackageTitle}>
                                    Buy Package Passes
                                </h1>
                            </>
                        ) : (
                            <></>
                        )
                    } */}
                    <h1 className={style.userPackageTitle}>
                        Buy Bettor Packages
                    </h1>

                    <div className={style.allPackages}>
                        {
                            allPackages.map((packagePass) => {
                                return <>


                                    {
                                        !packagePass.fields.top_selling ? (
                                            <>
                                                <div className={style.pack}>
                                                    <p className={style.packTitle}>{formatTitleText(packagePass.fields.package_type)}</p>
                                                    <p className={style.packPrice}>( only at {packagePass.fields.price} $ )</p>

                                                    {/* {
                                                        packagePass.fields.name == "DAILY_PASS" ? (
                                                            <>
                                                                <div className={style.packsTexts1}>
                                                                    <p className={style.pt_title}>Unlock new road</p>
                                                                    <ul className={style.pt_ul}>
                                                                        <li>Get all the picks in a Day </li>
                                                                        <li>Earn More</li>
                                                                        <li>Look inside Michis Picks</li>
                                                                    </ul>
                                                                </div>
                                                            </>
                                                        ) : (<></>)

                                                    } */}



                                                    <p className={style.packT1}>
                                                        🔓 Unlock 5 expert picks every day! Stay ahead of the game with insights tailored to maximize your winnings.
                                                    </p>

                                                    <div className={style.hrLine}></div>


                                                    <p className={style.packT2}>
                                                        {packagePass.fields.title}
                                                    </p>

                                                    <ul className={style.pt_ul2}>
                                                        <li dangerouslySetInnerHTML={{ __html: packagePass.fields.description }}></li>
                                                    </ul>
                                                            {
                                                                activePackages.some(pkg => pkg.fields.package == packagePass.pk) ? <>
                                                                <div className={style.upgradeButton} style={{ backgroundColor: "#BCC0BC" }}>
                                                                    Active 
                                                                </div>
                                                                </> : <>
                                                                    <div className={style.upgradeButton} onClick={(e) => { e.preventDefault(); buyPlan('package',packagePass.pk)}}>
                                                                        Upgrade 
                                                                    </div>
                                                                </>
                                                            }
                                                </div>
                                            </>
                                        ) :
                                            (
                                                <>
                                                    <div className={style.topSellingContainer}>
                                                        <div className={style.topSelling}>Top Selling</div>
                                                        <div className={`${style.pack} ${style.topSellingPack}`}>


                                                            <p className={style.packTitle}>{formatTitleText(packagePass.fields.package_type)}</p>
                                                            <p className={style.packPrice}>( only at {packagePass.fields.price} $ )</p>
                                                            {/* 
                                                            {
                                                                packagePass.fields.name == "DAILY_PASS" ? (
                                                                    <>
                                                                        <div className={style.packsTexts1}>
                                                                            <p className={style.pt_title}>Unlock new road</p>
                                                                            <ul className={style.pt_ul}>
                                                                                <li>Get all the picks in a Day </li>
                                                                                <li>Earn More</li>
                                                                                <li>Look inside Michis Picks</li>
                                                                            </ul>
                                                                        </div>
                                                                    </>
                                                                ) : (<></>)

                                                            } */}


                                                            <p className={style.packT1}>
                                                                🔓 Unlock 5 expert picks every day! Stay ahead of the game with insights tailored to maximize your winnings.
                                                            </p>

                                                            <div className={style.hrLine}></div>


                                                            <p className={style.packT2}>
                                                                💥 Upgrade to the Premium Pack for just $899 and enjoy 6 daily picks,
                                                            </p>

                                                            <ul className={style.pt_ul2}>
                                                                <li></li>
                                                            </ul>
                                                            {
                                                                 activePackages.some(pkg => pkg.fields.package == packagePass.pk)? <>
                                                                <div className={style.upgradeButton} style={{ backgroundColor: "#BCC0BC" }}>
                                                                    Active
                                                                </div>
                                                                </> : <>
                                                                    <div className={style.upgradeButton} onClick={(e) => { e.preventDefault(); buyPlan('package',packagePass.pk)}}>
                                                                        Upgrade
                                                                    </div>
                                                                </>
                                                            }

                                                        </div>
                                                    </div>
                                                </>
                                            )
                                    }

                                </>
                            })
                        }
                    </div>
                </div>
            </div>
        </>
    );
};

export default UpgradePage;